import {
  path,
  partial,
} from 'ramda';

import {
  CHANGE_ROW_SELECTION,
  RESET_ROWS_SELECTION,
  UPDATE_SORTING,
  INIT_TABLE,
  TOGGLE_EXPANDABLE_ROW,
} from './constants';

const getTableData = (state, props) => path(props, state);

const updateTableData = (state, props, data) => {
  if (props.length) {
    const prop = props.shift();

    return {
      ...state,
      [prop]: updateTableData(state[prop], props, data),
    };
  }

  return data;
};

const checkAllRowsSelection = (rows, selectionField) => rows
  .every((row) => row[selectionField] === undefined || row[selectionField]);

const changeRowSelection = (rows, id, isSelected, selectionField, uniqueIdField) => {
  const rowIndex = rows.findIndex((row) => row[uniqueIdField] === id);
  const row = rows[rowIndex];

  if (row && row[selectionField] !== undefined) {
    return [
      ...rows.slice(0, rowIndex),
      {
        ...row,
        [selectionField]: isSelected,
      },
      ...rows.slice(rowIndex + 1),
    ];
  }

  return rows;
};

const changeSelection = (state, config, { id, isSelected }) => {
  const {
    selectionField,
    uniqueIdField,
  } = config;
  const data = state.data
               && changeRowSelection(state.data, id, isSelected, selectionField, uniqueIdField);
  const isAllRowsSelected = data && checkAllRowsSelection(data, selectionField);

  return {
    ...state,
    data,
    isAllRowsSelected,
  };
};

const resetRowsSelection = (rows, selectionField, isAllRowsSelected = false) => rows
  .map((row) => (row[selectionField] === undefined ? row : {
    ...row,
    [selectionField]: isAllRowsSelected,
  }));

const resetSelection = (state, config, isAllRowsSelected = false) => {
  const { selectionField } = config;
  const data = state.data
                && resetRowsSelection(state.data, selectionField, isAllRowsSelected);

  return {
    ...state,
    data,
    isAllRowsSelected,
  };
};

const toggleExpandableRow = (state, config, { id, isExpanded }) => {
  const {
    uniqueIdField,
    expandField,
  } = config;

  const { data } = state;

  if (data) {
    const rowIndex = data.findIndex((row) => row[uniqueIdField] === id);
    const row = data[rowIndex];

    if (row) {
      return {
        ...state,
        data: [
          ...data.slice(0, rowIndex),
          {
            ...row,
            [expandField]: isExpanded,
          },
          ...data.slice(rowIndex + 1),
        ],
      };
    }
  }

  return state;
};

export default function (state = {}, action) {
  if (action.path) {
    const props = action.path.split('.');
    const tableState = getTableData(state, props);
    const performUpdate = partial(updateTableData, [state, props]);

    switch (action.type) {
      case CHANGE_ROW_SELECTION:
        return performUpdate(changeSelection(tableState, action.config, action.data));
      case RESET_ROWS_SELECTION:
        return performUpdate(resetSelection(tableState, action.config, action.data));
      case UPDATE_SORTING:
        return performUpdate({
          ...tableState,
          sortingInfo: action.data,
        });
      case INIT_TABLE:
        return performUpdate(resetSelection({
          ...tableState,
          sortingInfo: {},
        }, action.config));
      case TOGGLE_EXPANDABLE_ROW:
        return performUpdate(toggleExpandableRow(tableState, action.config, action.data));
      default:
        return state;
    }
  }

  return state;
}
